import API from "./api";
import API_ROUTES from "./apiRoutes";

export const createSupportTicket = async ({ subject, description }) => {
  const res = await API.post(API_ROUTES.supportTickets.create, { subject, description });
  return res.data;
};

export const getMySupportTickets = async () => {
  const res = await API.get(API_ROUTES.supportTickets.mine);
  return res.data;
};

export const getAdminSupportTickets = async ({ status, search, societyId, society_id } = {}) => {
  const params = {};
  if (status) params.status = status;
  if (search) params.search = search;
  const targetSocietyId = societyId || society_id;
  if (targetSocietyId) params.society_id = targetSocietyId;
  const res = await API.get(API_ROUTES.supportTickets.admin, { params });
  return res.data;
};

export const updateSupportTicketStatus = async (ticketId, status) => {
  const res = await API.patch(API_ROUTES.supportTickets.status(ticketId), { status });
  return res.data;
};

